import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import MarqueeSection from "@/components/MarqueeSection";
import NetworkGlobe from "@/components/NetworkGlobe";
import SecurityDashboard from "@/components/SecurityDashboard";
import Stats from "@/components/Stats";
import FAQ from "@/components/FAQ";
import FeaturedArticles from "@/components/FeaturedArticles";
import ContactForm from "@/components/ContactForm";
import { useSEO } from "@/lib/useSEO";

export default function Home() {
  useSEO({
    title: "Endasphere — Global Security & Network Infrastructure | Anything in the Sphere is Protected",
    description:
      "Endasphere is a global network and infrastructure provider that protects and accelerates websites, apps and APIs. Malware detection, privacy, theft prevention, real-time game cheat detection, cloud servers and a reverse-proxy CDN across 312 edge locations.",
    keywords:
      "cybersecurity, reverse proxy, CDN, malware detection, DDoS protection, game cheat detection, anti-cheat, privacy, theft prevention, cloud servers, network infrastructure, WAF, edge network, Endasphere",
    path: "/",
  });

  return (
    <>
      <Hero />
      <Services />
      <MarqueeSection />
      <Manifesto />
      <NetworkGlobe />
      <SecurityDashboard />
      <Stats />
      <FAQ />
      <FeaturedArticles />
      <ContactForm />
    </>
  );
}
